"use client";

import { Button, Card, Container, Group, rem, SimpleGrid, Text, Title } from "@mantine/core";
import { IconArrowRight, IconBrain } from "@tabler/icons-react";

import { DECISION_MAKING_FRAMEWORKS } from "@/app/(marketing)/decision-making-frameworks/constants";
import { NextLink } from "@/app/lib/components/next/NextLink";

export default function DecisionMakingFrameworksPage() {
  return (
    <Container size="lg" py="xl">
      <Title order={1} mb="lg" ta="center">
        Decision-Making Frameworks
      </Title>
      <Text size="lg" c="dimmed" mb="xl" ta="center">
        Tools and frameworks to help you make better decisions by structuring your thinking process
      </Text>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
        {Object.values(DECISION_MAKING_FRAMEWORKS).map((framework) => (
          <Card key={framework.name} shadow="sm" padding="lg" radius="md" withBorder>
            <Group mb="md">
              <IconBrain style={{ width: rem(24), height: rem(24) }} />
              <Title order={3}>{framework.name}</Title>
            </Group>

            <Text lineClamp={3} mb="md">
              {framework.description}
            </Text>

            <Button
              component={NextLink}
              href={framework.help_url}
              variant="light"
              color="blue"
              rightSection={<IconArrowRight size={14} />}
            >
              Learn More
            </Button>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
}
